import React, { useReducer } from 'react'

const initialFilterState = {
    search: '',
    sort_by: ''
}

const filterReducer = (state, action) => {
    switch (action.type) {
        case 'search': {
            return {
                ...state,
                search: action.value
            }
        }
        case 'sort': {
            return {
                ...state,
                sort_by: action.sort_by
            }
        }
        default:
            return state
    }
}

export const useHotswapFilters = initialFilters =>
    useReducer(filterReducer, { ...initialFilterState, ...initialFilters })
